module.exports = __webpack_public_path__ + "assets/500.669aaa8f.svg";